import { gql } from "@apollo/client";

import type { DraftPreviewButton } from "@/graphql/get-draft-preview";

export const GET_PUBLISHED_PREVIEW = gql`
  query GetPublishedPreview($instagramUsername: String!) {
    publishedPreview(instagramUsername: $instagramUsername) {
      id
      instagramUsername
      language
      hasIntroduction
      hasProfileHeader
      introductionText
      css
      buttons {
        url
        text
        enabled
      }
      hasGallery
      galleryTitle
      galleryId
      instagram {
        profileImageUrl
      }
      updatedAt
    }
  }
`;

export interface PublishedPreview {
  id: string;
  instagramUsername: string;
  language: string | null;
  hasIntroduction: boolean;
  hasProfileHeader: boolean;
  introductionText: string | null;
  css: string | null;
  buttons: DraftPreviewButton[];
  hasGallery: boolean;
  galleryTitle: string | null;
  galleryId: string | null;
  instagram: { profileImageUrl: string | null } | null;
  updatedAt: string;
}

export interface GetPublishedPreviewData {
  publishedPreview: PublishedPreview;
}

export interface GetPublishedPreviewVariables {
  instagramUsername: string;
}
